import {
    IonAvatar,
    IonCol, 
    IonIcon,
    IonImg,
    IonItem,
    IonLabel,
    IonNote,
    IonRow,
    IonGrid,
    IonBadge,
    IonThumbnail,
    useIonRouter,
    IonText,
    IonChip,
    IonPopover,
    IonContent,
    IonButton,
    IonButtons,
    IonToolbar,
    IonModal,
    IonSpinner,
    IonList
} from '@ionic/react';
import React, { Component, useRef, useState }  from 'react';
import { people, heartCircleOutline, heartOutline, closeOutline, ellipsisVertical, happyOutline, happy, ellipsisHorizontal, giftOutline, image, arrowForwardCircleOutline } from 'ionicons/icons';
import { MsgData, MsgDataGroup, MsgThread } from '../data/message';
import { LANGUAGE, GetStr } from "../language/Language";
import NServer, { handleRouteError } from "../components/NServer";
import Vault from '../components/Vault';
import EmoComp from '../components/EmoComp';
import { showAlert } from '../components/Alert';
import { ItemInfo } from '../data/item';

import '../pages/Main.css';
import '../pages/ChatMsg.css';


interface ChatMsgGroupProp {
    group : MsgDataGroup;
    action : any;
    emo : any;
    like : any;
    ctype : string;
}

interface ChatMsgProp {
    msg : MsgData;
    owned : boolean;
    action : any;
    emo : any;
    like : any;
    ctype : string;
}

// retrieve number part of a string
const numberOnly = (str : string) : string => {
    var matches = str.match(/[+-]?\d+(\.\d+)?/g);
              
    if (matches) {
        return matches[0];
    }
    // else
    return "0";
}

const ChatItem : React.FC<ChatMsgProp> = ({ msg, owned, action, emo, like, ctype }) => {

    const popover = useRef<HTMLIonPopoverElement>(null);
    const [emoOpen, setEmoOpen] = useState(false);
    const [likeBox, showLikes] = useState(false);
    const [supporterLoading, setSupporterLoading] = useState(false);
    const [supporters, setSupporters] = useState<ItemInfo[]>([]);

    //	Initializing our router
	const router = useIonRouter();

    const gotoPost = () => {
        router.push("/content/" + msg.extra.id + "/msg", "forward", "push");
    }

    // image click event
    const ImgClick = () => {
        router.push("/imgviewer/" + encodeURIComponent(msg.msg) + "/0/0/image", "forward", "push");
    }

    // click on emo panel
    const onEmoPanel = () => {
        showLikes(true);
        getSupporters();
    }

    const openEmoBar = (e: any) => {
        popover.current!.event = e;
        setEmoOpen(true);
    };

    // react emo to the message
    const reactEmo = async (index : number) => {
        setEmoOpen(false);
        emo(msg, index);
    }

    // click on item
    const onLikeUserClicked = (item : ItemInfo) => {
        showLikes(false);
        if (item != null)
            router.push("/user/" + item.id, "forward", "push");
    }

    // load the supporters
    const getSupporters = async () => {
        setSupporterLoading(true);

        // send like to server
        let v = new Vault();
        await v.read();

        const state = {
            id: v.account.id,
            pass: v.account.key,
            mid: msg.id,
        }

		var server = new NServer();
        await server.getList("msg_reacts", state);

        if (!server.success && server.message != "")
            showAlert(server.message);
        else
        {
            setSupporters(server.data);
            setSupporterLoading(false);
        }
    }

    // send like function
    const sendLike = (likes : number) => {
        setEmoOpen(false);
        like(msg.id, likes);
    }

    if (msg.type == "del")
    {
        return (
            <div className={ owned ? "del-msg msg-right" : "del-msg msg-left" }>
                <i>{ GetStr(LANGUAGE.TXT_THIS_MSG_DELETED) }</i>
            </div>
        )
    }

    if (msg.type == "info")
    {
        return (
            <div className={ owned ? "msg-right" : "msg-left" }>
                <IonChip className="msg-info-chat">{ msg.msg }</IonChip>
            </div>
        )
    }

    return (
        <div className={ owned ? "msg-right" : "msg-left" } >
            {
                owned ?
            <div className={ "msg-emo-opt" }>
                <IonButton className="ion-no-padding" fill="clear" onClick={ ()=> action(msg) }>
                    <IonIcon className="msg-emo-but" icon={ellipsisVertical} color="medium" />
                </IonButton>&nbsp;
            </div>
                :
            <div/>
            }
            <IonBadge className={ msg.format } >
                {
                    /* show reply if there any */
                    msg.ref_name != "" ?
                <div className="reply-inside">
                    <IonText color="medium">
                        { ctype != "rchat" ? <b>{ msg.ref_name }</b> : <div/> }
                        <div className="reply-inside-comment">{ msg.ref_msg }</div>
                    </IonText>
                </div>
                    :
                <div/>
                }
                {
                    msg.showName ?
                <div className="msg-name">{ msg.name }&nbsp;&nbsp;{ msg.followed ? <IonIcon icon={people} /> : <div/> }</div>
                    :
                <div/>
                }
                { 
                    /* post sharing */
                    msg.type == "post" ?
                <div>
                    <div className="msg-share-txt"><i>{ GetStr(LANGUAGE.TXT_MSG_SHAREAPOST_TAG) }</i></div>
                    <IonImg className="msg-post-img" src={msg.extra.icon} onClick={ gotoPost }/>
                    <div className="msg-share-title" onClick={ gotoPost }>{ msg.extra.title }</div>
                </div>
                    :
                    /* money transfer */
                    msg.type == "money" ?
                <div className="msg-balance-card">
                    <div><small>{ GetStr(LANGUAGE.TXT_MSG_SENT_MONEY_TAG) }</small></div>
                    <IonText className="balance-text-sml">${ numberOnly(msg.msg) }</IonText>
                    <div>
                        <IonButton fill="clear" color="secondary" routerLink="/token/wallet"><b>{ GetStr(LANGUAGE.TXT_MSG_OPEN_WALLET) }</b></IonButton>
                    </div>
                </div>
                    :
                    /* image share */
                    msg.type == "img" ?
                <IonImg className="img-inner" src={msg.msg} onClick={ImgClick} />
                    :
                    /* normal msg */
                <IonText>{ msg.msg }</IonText>
                }
                {
                    /* emoticons */
                    msg.emo != "" ?
                <div className="msg-emo-panel" onClick={ onEmoPanel }>
                    <IonChip><IonText color="light">{ msg.emo }</IonText></IonChip>
                </div>
                    :
                <div/>
                }
            </IonBadge>
            {
                !owned ?
            <div className={ "msg-emo-opt" }>
                <IonButton className="ion-no-padding" fill="clear" onClick={openEmoBar}>
                    <IonIcon className="msg-emo-but" icon={happyOutline} color="medium" />
                </IonButton>
                <IonButton className="ion-no-padding" fill="clear" onClick={ ()=> action(msg) }>
                    <IonIcon className="msg-emo-but" icon={ellipsisVertical} color="medium" />
                </IonButton>
            </div>
                :
            <div/>
            }
            { /* emoticon menu */ }
            <IonPopover ref={popover} className="msg-emo-menu" isOpen={emoOpen}
                showBackdrop={false} size="auto"
                side="bottom" alignment="start"
                onDidDismiss={ () => setEmoOpen(false) } 
            >
                <IonContent>
                    <IonButtons>
                        <IonButton className="chat-like-but" onClick={ ()=> sendLike(1) } >
                            <IonIcon icon={heartOutline} />&nbsp;
                            Like
                        </IonButton>
                        <IonButton className="chat-like-but" onClick={ ()=> sendLike(10) } >
                            <IonIcon icon={heartCircleOutline} />&nbsp;
                            Super
                        </IonButton>
                    </IonButtons>
                    <IonButtons>
                        <IonButton className="chat-emo-but" onClick={ ()=> reactEmo(0) }>👍</IonButton>
                        <IonButton className="chat-emo-but" onClick={ ()=> reactEmo(1) }>😂</IonButton>
                        <IonButton className="chat-emo-but" onClick={ ()=> reactEmo(2) }>❤️</IonButton>
                        <IonButton className="chat-emo-but" onClick={ ()=> reactEmo(3) }>😢</IonButton>
                        <IonButton className="chat-emo-but" onClick={ ()=> reactEmo(4) }>😡</IonButton>
                    </IonButtons>
                </IonContent>
            </IonPopover>
            { /* emotion users */ }
            <IonModal
                isOpen={likeBox}
                initialBreakpoint={0.4}
                breakpoints={[0.4, 0.75, 1.0]}
                backdropDismiss={true}
                onDidDismiss={() => showLikes(false)}
                >
                <div className="ion-page">
                    <IonToolbar id="modal">
                        <IonButtons slot="end">
                            <IonButton onClick={()=>{showLikes(false)}}>
                                <IonIcon icon={closeOutline} size="large"/>
                            </IonButton>
                        </IonButtons>
                    </IonToolbar>
                    <IonContent>
                        {
                            supporterLoading ?
                        <div className="headerCenter">
                            <IonSpinner name="crescent" />
                        </div>
                            :
                            supporters.length == 0 ?
                        <div className="headerCenter">
                            <IonText color="medium">{ GetStr(LANGUAGE.TXT_NO_LIKE_POST) }</IonText>
                        </div>
                            :
                        <IonList>
                            { 
                                supporters.map((m) => 
                                <EmoComp key={m.id} item={m} submit={onLikeUserClicked} />
                                )
                            }
                        </IonList>
                        }
                    </IonContent>
                </div>
            </IonModal>
        </div>
    );
};

const ChatMsgGroup : React.FC<ChatMsgGroupProp> = ({ group, action, emo, like, ctype }) => {

    //	Initializing our router
	const router = useIonRouter();

    const clickAvatar = () => {
        if (ctype != "rchat")
            router.push("/user/" + group.sender, "forward", "push");
    }

    // for owner chat box
    if (group.owned) {
    return (
        <IonGrid className="full-width">
            <IonRow>
                <IonCol>
                {
                    group.messages.map(m => 
                        <ChatItem key={m.id} msg={m} owned={group.owned} action={action} emo={emo} like={like} ctype={ctype} />
                    )
                }
                    <div className="timestamp ion-text-right" >
                        { group.last_sent }
                    </div>
                </IonCol>
            </IonRow>
        </IonGrid>
    );
    }
    // else
    // Other user chatbox
    return (
        <IonGrid className="full-width">
            <IonRow>
                <IonCol className="chat-avt-col">
                    <IonAvatar className="avt-size" onClick={clickAvatar}>
                        <img src={group.avatar} onError={ ({currentTarget}) => { currentTarget.src = '/assets/img/avt.jpg' } } />
                    </IonAvatar>
                </IonCol>
                <IonCol>
                    {
                        group.messages.map(m => 
                            <ChatItem key={m.id} msg={m} owned={group.owned} action={action} emo={emo} like={like} ctype={ctype} />
                        )
                    }
                    <div className="timestamp ion-text-left" >
                        { group.last_sent }
                    </div>
                </IonCol>
            </IonRow>
        </IonGrid>
    );
};

export default ChatMsgGroup;

